import { z } from 'zod'

/**
 * Admin login form schema (DEC-ADMIN-001 / DEC-FE-013).
 *
 * A `POST /admin/auth/login` body — egyszerű email + password. Az admin
 * regisztráció CLI-szintű (`php artisan admin:create`), public sign-up
 * **szándékosan nincs** — a login a kizárólagos admin auth-belépő.
 */
export const loginSchema = z.object({
  email: z.string().min(1, 'Az email cím kötelező').email('Érvénytelen email cím'),
  password: z.string().min(1, 'A jelszó kötelező'),
})

export type LoginFormValues = z.infer<typeof loginSchema>

/**
 * Email-2FA step 2 (DEC-ADMIN-011) — a 6 jegyű, email-be küldött kód. A
 * `POST /admin/auth/mfa/verify` body `code` mezője.
 */
export const mfaSchema = z.object({
  code: z
    .string()
    .min(1, 'A kód kötelező')
    .regex(/^\d{6}$/, 'A kód 6 számjegy'),
})

export type MfaFormValues = z.infer<typeof mfaSchema>
